import { RefObject, ChangeEvent } from 'react';
import { Tag, Button, Popover, Space, Input } from 'antd';
import Icon, { SearchOutlined } from '@ant-design/icons';
import FilterDropdown from './FilterDropdown';
import { mapAppliedFiltersToDisplayText } from './Fallbacks.utils';
import { useTranslation } from 'react-i18next';
import IconConfigure from '@/assets/icon-configure.svg?react';

interface SearchFilterSectionProps {
  inputValue: string;
  onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSearchSubmit: () => void;
  onSearchClear: () => void;
  onSearchIconClick: () => void;

  isFilterModalOpen: boolean;
  onFilterApply: (filters) => void;
  onFilterClose: () => void;
  onAppliedFiltersClose: () => void;
  appliedFilters;
  hasFiltersApplied: boolean;
  filterButtonRef: RefObject<HTMLDivElement>;
  onFilterModalOpenChange: (open: boolean) => void;

  
  isDraftMode: boolean;
  onRemoveScenario: () => void;
  onUpdateScenario: () => void;
  onCreateFallback: () => void;
  isUpdateLoading: boolean;
  isUpdateDisabled: boolean;

  
  totalCount: number;
}

const SearchFilterSection = ({
  inputValue,
  onInputChange,
  onSearchSubmit,
  onSearchClear,
  onSearchIconClick,
  isFilterModalOpen,
  onFilterApply,
  onFilterClose,
  onAppliedFiltersClose,
  appliedFilters,
  hasFiltersApplied,
  filterButtonRef,
  onFilterModalOpenChange,
  isDraftMode,
  onRemoveScenario,
  onUpdateScenario,
  onCreateFallback,
  isUpdateLoading,
  isUpdateDisabled,
  totalCount,
}: SearchFilterSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="search-filter-section">
      <div className="search-filter-row">
        <Input
          className="input-fallback-two-point-o"
          placeholder={t('searchByNumber')}
          value={inputValue}
          onChange={onInputChange}
          allowClear
          onPressEnter={onSearchSubmit}
          onClear={onSearchClear}
          suffix={
            <div className="search-suffix" onClick={onSearchIconClick}>
              <SearchOutlined className="search-icon" />
            </div>
          }
        />

        <Popover
          content={
            <FilterDropdown onClose={onFilterClose} onApply={onFilterApply} />
          }
          trigger="click"
          open={isFilterModalOpen}
          onOpenChange={onFilterModalOpenChange}
          placement="bottomLeft"
        >
          <div ref={filterButtonRef}>
            <Button className="filter-button-fallback-two-point-o">
              <Icon component={IconConfigure} />
              Filter
            </Button>
          </div>
        </Popover>

        <div className="applied-filters-container">
          {hasFiltersApplied && (
            <Tag
              closable
              onClose={onAppliedFiltersClose}
              className="applied-filter-tag-fallback-two-point-o"
            >
              {mapAppliedFiltersToDisplayText(appliedFilters, t)}
            </Tag>
          )}
        </div>

        {isDraftMode && (
          <div className="new-fallback-button-container">
            <Space className="action-buttons-container-fallback-two-point-o">
              <Button
                type="primary"
                onClick={onRemoveScenario}
              >
                {t('removeScenario')}
              </Button>
              <Button
                type="primary"
                onClick={onUpdateScenario}
                loading={isUpdateLoading}
                disabled={isUpdateDisabled}
              >
                {t('updateScenario')}
              </Button>
            </Space>
            <Button type="primary" onClick={onCreateFallback}>
              + {t('newFallback')}
            </Button>
          </div>
        )}
      </div>
      <div className="fallback-count-fallback-two-point-o">
        {totalCount} {t('fallbacks')}
      </div>
    </div>
  );
};

export default SearchFilterSection;
